// helpers
import { ApiHelper } from 'shared/helpers/api';
import { getAdPlatformURL, ROUTES } from 'shared/api/urls';

// helpers
import { getDeviceType } from 'shared/components/ResponsiveLoader/helpers';
import { getDomainConfig } from 'shared/domainConfig/helpers';
import { buildStoreRedirectId, DEFAULT_STORE } from 'shared/helpers/storeUrl';
import { normalizePageName } from 'shared/routes/LandingPage/helpers';

// constants
import { RENDER_MODE } from 'shared/constants';

const getPlatformIdentifier = () => {
  const serverRenderMode = getDeviceType();

  return serverRenderMode === RENDER_MODE.DESKTOP ? 'dweb' : 'mweb';
};

export interface LandingPageProps {
  pageName: string;
  headers: Record<string, string>;
  experiments?: Record<string, string>;
  pageData?: string;
  shouldFetchAdPlatformV2?: boolean;
  storeId?: string;
}

export const getLandingPageData = ({
  headers,
  pageName,
  experiments = {},
  pageData,
  shouldFetchAdPlatformV2 = false,
  storeId,
}: LandingPageProps): Promise<object> => {
  const baseUrl = getAdPlatformURL(ROUTES.AD_PLATFORM_API);
  const { DN_STORE } = getDomainConfig();
  const params = new URLSearchParams();

  let normalizedPageNameValue = pageName;
  if (shouldFetchAdPlatformV2) {
    // Remove store prefix (e.g., 'nf-') from pageName and pass store as separate param
    normalizedPageNameValue = normalizePageName(pageName);
    params.append('store', DN_STORE);
  }
  if (storeId !== DEFAULT_STORE) {
    params.append('sub_stores', buildStoreRedirectId(storeId));
  }
  
  params.append('page_type', normalizedPageNameValue);
  params.append('page_section', '*');
  params.append('platform', getPlatformIdentifier());

  Object.keys(experiments).forEach((experimentId) => {
    params.append(experimentId, experiments[experimentId]);
  });

  if (pageData) {
    params.append('page_data', pageData);
  }

  const url = `${baseUrl}?${params.toString()}`;

  return ApiHelper(url, { headers }).then(async (response: Response) => {
    if (response.ok) {
      try {
        return await response.json();
      } catch {
        return Promise.reject();
      }
    }
    return Promise.reject();
  });
};
